const FieldsDeviation = {
  fields: [
    { 
      key: 'indicator',
      label: "indicador-0", 
      sortable: true 
    },
    { 
      key: 'process',
      label: "processo", 
      sortable: true 
    },
    { 
      key: 'product',
      label: "produto-0",  
      sortable: true,
    },
    { 
      key: 'equipment',
      label: "equipamento", 
      sortable: true 
    },
    { 
      key: 'vlv',
      label: "vlv", 
      sortable: true,
    },
    { 
      key: "vfr", 
      label: "vfr", 
      sortable: true 
    },
    { 
      key: "vlt", 
      label: "vlt", 
      sortable: true 
    },
    { 
      key: "alt", 
      label: "alt", 
      sortable: true 
    },
    { 
      key: "ald", 
      label: "ald", 
      sortable: true 
    },
    { 
      key: "ats", 
      label: "ats", 
      sortable: true 
    },
    { 
      key: "adi", 
      label: "adi", 
      sortable: true 
    },
    { 
      key: "atm", 
      label: "atm", 
      sortable: true 
    },
    { 
      key: "vmd", 
      label: "vmd", 
      sortable: true 
    },
    { 
      key: "vmt", 
      label: "vmt", 
      sortable: true 
    },
    { 
      key: "amh", 
      label: "amh", 
      sortable: true 
    },
    { 
      key: "rfg", 
      label: "rfg", 
      sortable: true 
    },
    { 
      key: "rfi", 
      label: "rfi", 
      sortable: true 
    },
    { 
      key: "rsg", 
      label: "rsg", 
      sortable: true 
    },
    {
      key: "vmh",
      label: "vmh",
      sortable: true
    },
    {
      key: "vmw",
      label: "vmw",
      sortable: true
    },
    {
      key: "actions", 
      label: "actions"
    },

    




  ],
}

export default FieldsDeviation
